var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "listView", style: { width: _vm.width } },
    [
      _vm._l(_vm.data, function (item, index) {
        return [
          index < 5
            ? _c(
                "div",
                { key: index, staticClass: "listLi", style: _vm.listyle },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: item.nickName,
                        placement: "top-start",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text_hidden_ellipsis",
                          attrs: { title: item.nickName },
                        },
                        [_vm._v(_vm._s(item.nickName))]
                      ),
                    ]
                  ),
                  _vm.del
                    ? _c("i", {
                        staticClass: "el-icon-close m-l-8 delBtn",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("onDel", item)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _vm.data.length > 0
        ? _c("div", { staticClass: "listLi More", style: _vm.listyle }, [
            _c(
              "span",
              { staticClass: "pointer", on: { click: _vm.handleClickMore } },
              [_vm._v("更多...")]
            ),
          ])
        : _vm._e(),
      _c("moreAssistant", {
        ref: "moreAssistant",
        attrs: { config: _vm.moreAssistantConfig, disabled: _vm.disabled },
        on: {
          autoAllocation: (res) => _vm.$emit("autoAllocation", res),
          unAutoAllocation: (res) => _vm.$emit("unAutoAllocation", res),
          onDel: (res) => _vm.$emit("onDelBatch", res),
          onAdd: (res) => _vm.$emit("onAdd", res),
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }